import { VIEW_WIDTH_CSS_VAR } from '../constants/common';

const getViewLeftOffset = () => {
  const value = document.body.style.getPropertyValue(VIEW_WIDTH_CSS_VAR);

  if (!value || value === '100%') return 0;

  const viewWidth = parseInt(value, 10);

  return Math.max(0, (window.innerWidth - viewWidth) / 2);
};

export default getViewLeftOffset;
